import React, { useState, useEffect } from 'react';
import { getApiBaseUrl } from '../config/api';

const SystemStatus: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'healthy' | 'unhealthy'>('loading');
  const [message, setMessage] = useState('系統檢查中...');

  useEffect(() => {
    const checkHealth = async () => {
      const API_BASE_URL = getApiBaseUrl();
      console.log('🔧 健康檢查 API URL:', `${API_BASE_URL}/api/health`);

      let retryCount = 0;
      const maxRetries = 2; // 健康檢查重試次數較少

      while (retryCount <= maxRetries) {
        try {
          const response = await fetch(`${API_BASE_URL}/api/health`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'omit',
          });

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
          }

          const data = await response.json();

          if (data.status === 'healthy') {
            setStatus('healthy');
            setMessage('🟢 AI 連線正常');
            return; // 成功則返回
          } else {
            throw new Error(`健康檢查失敗: ${data.status}`);
          }
        } catch (error: any) {
          console.warn(
            `⚠️ 健康檢查失敗 (嘗試 ${retryCount + 1}/${maxRetries + 1}):`,
            error.message
          );

          if (retryCount === maxRetries) {
            // 最後一次重試失敗
            setStatus('unhealthy');

            let errorMessage = '未知錯誤';
            if (error instanceof TypeError && error.message.includes('fetch')) {
              errorMessage = '無法連接到後端服務';
            } else if (error.message.includes('CORS')) {
              errorMessage = 'CORS連接問題';
            } else if (error.message.includes('NetworkError')) {
              errorMessage = '網路連接問題';
            } else {
              errorMessage = error.message || '連接失敗';
            }

            setMessage(`🔴 AI 連線失敗: ${errorMessage}`);
            return;
          }

          retryCount++;
          // 短暫等待後重試
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
    };

    checkHealth();
  }, []);

  return (
    <div
      className={`system-status ${status === 'healthy' ? 'status-healthy' : 'status-unhealthy'}`}
    >
      {message}
    </div>
  );
};

export default SystemStatus;
